import script from "./CreatePlayerForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatePlayerForm.vue?vue&type=script&setup=true&lang=js"

import "./CreatePlayerForm.vue?vue&type=style&index=0&id=76021bd7&lang=css"

const __exports__ = script;

export default __exports__